import { render, staticRenderFns } from "./AdminExcludedPlacementsComponent.vue?vue&type=template&id=02d3fb6f"
import script from "./AdminExcludedPlacementsComponent.vue?vue&type=script&lang=js"
export * from "./AdminExcludedPlacementsComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminExcludedPlacementsComponent.vue?vue&type=style&index=0&id=02d3fb6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports